import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from "primereact/panel";
import CardResumo, { periodoOcorrencias, valorBR } from "./CardResumo";

const lista = (valor: any): any[] => Array.isArray(valor) ? valor : [];

// Resumo em cards das seções de restrição que são exibidas em painéis separados
// (Apontamentos, Cheques sem Fundos, Ações, Protestos SP e Últimas Consultas)
export default function ResumoRestricoes({
  apontamentos,
  ccfs,
  acoes,
  protestos,
  consulta,
}: {
  apontamentos?: any[];
  ccfs?: any[];
  acoes?: any[];
  protestos?: any[];
  consulta?: any;
}) {
  const { t } = useTranslation();

  const somar = (itens: any[], campo: string) => itens.reduce((total, item) => total + valorBR(item?.[campo]), 0);

  const consultas = lista(consulta?.consultas);
  const quantidadePorFaixa = ['quantidade30Dias', 'quantidade31a60Dias', 'quantidade61a90Dias', 'quantidadeMais90Dias']
    .reduce((total, campo) => total + (Number(consulta?.[campo]) || 0), 0);

  // Só entram os cards das seções presentes na resposta, na ordem definida pelo cliente
  const cards = [
    apontamentos !== undefined && {
      titulo: 'Apontamentos',
      quantidade: lista(apontamentos).length,
      valor: somar(lista(apontamentos), 'valor'),
      ...periodoOcorrencias(lista(apontamentos).map(a => a.dataRegistro)),
    },
    ccfs !== undefined && {
      titulo: 'Cheques sem Fundos',
      quantidade: lista(ccfs).length,
      ...periodoOcorrencias(lista(ccfs).map(c => c.ultimaOcorrencia)),
    },
    acoes !== undefined && {
      titulo: 'Ações, Falências e Recuperações Judiciais',
      quantidade: lista(acoes).length,
      valor: somar(lista(acoes), 'valor'),
      ...periodoOcorrencias(lista(acoes).map(a => a.dataDistribuicao)),
    },
    protestos !== undefined && {
      titulo: 'Protestos SP',
      quantidade: lista(protestos).reduce((total, p) => total + (Number(p?.quantidade) || 0), 0),
      valor: somar(lista(protestos), 'valor'),
    },
    consulta && {
      titulo: 'Últimas Consultas Realizadas',
      quantidade: quantidadePorFaixa || consultas.reduce((total, c) => total + (Number(c?.quantidade) || 0), 0),
      destacar: false,
      ...periodoOcorrencias(consultas.map(c => c.data)),
    },
  ].filter(Boolean) as { titulo: string, quantidade: number, valor?: number, primeira?: string, ultima?: string, destacar?: boolean }[];

  if (cards.length === 0) return null;

  return (
    <Panel headerTemplate={(options: PanelHeaderTemplateOptions) => (
      <div className={`${options.className} `}>
        <span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>{t('Resumo de Restrições')}</span>
      </div>
    )}>
      <div className="flex-consulta flex-wrap gap-3">
        {cards.map(card => <CardResumo key={card.titulo} {...card} />)}
      </div>
    </Panel>
  );
}
